import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 overflow-x-auto min-h-[520px]"
}
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_4 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_5 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_8 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_11 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_12 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_13 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_17 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_18 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_19 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_22 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_23 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_24 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_27 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_28 = { class: "flex items-center" }
const _hoisted_29 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_30 = { class: "px-2 py-2" }
const _hoisted_31 = { class: "px-2 py-2" }
const _hoisted_32 = { class: "px-2 py-2 capitalize" }
const _hoisted_33 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_34 = { class: "px-2 py-2 capitalize" }
const _hoisted_35 = { class: "px-2 py-2 capitalize" }
const _hoisted_36 = { class: "px-2 py-2 capitalize" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "px-2 py-2 capitalize" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "px-2 py-2 capitalize" }
const _hoisted_43 = { class: "px-2" }

import { PropType, ref, watch } from "vue";
import { useRoute } from "vue-router";

import PaginationBar from "../PaginationBar.vue";
import ToggleCheckbox from "../ToggleCheckbox.vue";
import TransactionBadge from "../TransactionBadge.vue";
import FilterTableHeader from "./FilterTableHeader.vue";
import SearchTableHeader from "./SearchTableHeader.vue";
import SubscriptionBadge from "../SubscriptionBadge.vue";
import SortableTableHeader from "./SortableTableHeader.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { User } from "@/types";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionsTable',
  props: {
  showFilters: {
    type: Boolean,
    required: false,
    default: false,
  },
  filters: {
    type: Object as PropType<any>,
    required: false,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();

const globalStore = useGlobalStore();
const { setFilter, resetFilters, filters, getFiltersFromQuery, setFilterNoRefresh, sortBy } = useFilters(route);

const users = ref([] as any[]);
const emails = ref([] as any[]);



const paymentMethodsFilter = ["2Checkout", "Invoice", "Stripe", "Manual"];
const statusFilters = ["active", "pending", "expired", "cancelled", "none"];

const subscriptions = ref([] as User[]);
const meta = ref({} as any);

async function markAsInvoiceIssued(id: string) {
  try {
    const response = await api.subscriptions.markSubscriptionInvoiceIssued(id);
    const issued = response.data.transaction.invoice_issued ? "issued" : "not issued";

    globalStore.toast("SUCCESS", `Invoice marked as ${issued}`);

    await search(); // Refresh the subscriptions list after updating
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Invoice order`);
  }
}

async function markAsInvoiceAsPaid(id: string) {
  try {
    const response = await api.subscriptions.markSubscriptionInvoiceAsPaid(id);
    globalStore.toast("SUCCESS", `Invoice marked as ${response.data.transaction.processed ? "paid" : "not paid"}`);

    await search(); // Refresh the subscriptions list after updating
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function search() {
  const response = await api.subscriptions.listSubscriptions(filters.value as any);
  subscriptions.value = response.data.subscriptions;

  meta.value = response.meta;
  users.value = response.data.users.map((user: any) => ({
    key: `${user.first_name} ${user.last_name}`,
    value: user.id,
  }));

  emails.value = response.data.users.map((user: any) => ({
    key: user.email,
    value: user.id,
  }));
}

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

watch(route.query, () => {
  if (route.query.tab !== "subscriptions") {
    setFilterNoRefresh("tab", "subscriptions");
    console.log(filters.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (subscriptions.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_3, [
              _createElementVNode("th", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`placed`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "transactions.created_at",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`name`)), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(SortableTableHeader, {
                      column: "last_name",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"]),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(SearchTableHeader, {
                          key: 0,
                          display_property: "name",
                          search_term: "last_name",
                          label: "user_id",
                          filter_property: "id",
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`email`)), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(SearchTableHeader, {
                          key: 0,
                          display_property: "email",
                          search_term: "email",
                          label: "user_id",
                          filter_property: "id",
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`type`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "transactions.type",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`renewal-date`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "subscription_end",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`auto-renewal`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "auto_renew",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-gateway`)), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(SortableTableHeader, {
                      column: "subscription_merchant_name",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"]),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "method",
                          currentValue: _unref(filters).method,
                          filters: paymentMethodsFilter,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`invoice-issued`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "transactions.invoice_issued",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`paid`)), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(SortableTableHeader, {
                      column: "transactions.processed",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"])
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`status`)), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(SortableTableHeader, {
                      column: "subscription_status",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"]),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "status",
                          currentValue: _unref(filters).status,
                          filters: statusFilters,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptions.value, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: user.id
              }, [
                _createElementVNode("td", _hoisted_29, _toDisplayString(user.subscriptionTransaction ? new Date(user.subscriptionTransaction.created_at).toDateString() : ""), 1),
                _createElementVNode("td", _hoisted_30, [
                  _createVNode(_component_router_link, {
                    class: "text-blue-500 underline capitalize whitespace-nowrap md:whitespace-normal",
                    to: { name: 'User_Profile', params: { id: user.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", _hoisted_31, _toDisplayString(user.email), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(user.subscriptionTransaction ? (user.subscriptionTransaction!.type === "Subscription" ? _ctx.$t("individual") : _ctx.$t("group")) : ""), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(user.subscription_end === null ? "" : new Date(user.subscription_end).toDateString()), 1),
                _createElementVNode("td", _hoisted_34, _toDisplayString(user.auto_renew ? _ctx.$t("yes") : _ctx.$t("no")), 1),
                _createElementVNode("td", _hoisted_35, _toDisplayString(user.subscriptionTransaction ? user.subscriptionTransaction!.payment_gateway : ""), 1),
                _createElementVNode("td", _hoisted_36, [
                  (user.subscriptionTransaction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        (user.subscriptionTransaction?.payment_gateway !== 'Invoice')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                          : _createCommentVNode("", true),
                        (user.subscription_status !== 'expired' && user.subscriptionTransaction?.payment_gateway === 'Invoice')
                          ? (_openBlock(), _createBlock(ToggleCheckbox, {
                              key: 1,
                              value: user.subscriptionTransaction!.invoice_issued,
                              onToggle: ($event: any) => (markAsInvoiceIssued(user.subscriptionTransaction!.id))
                            }, null, 8, ["value", "onToggle"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_39, [
                  (user.subscription_status !== 'expired' && user.subscriptionTransaction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        (user.subscriptionTransaction?.payment_gateway !== 'Invoice')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                              _createVNode(TransactionBadge, {
                                transaction: user.subscriptionTransaction!
                              }, null, 8, ["transaction"])
                            ]))
                          : (_openBlock(), _createBlock(ToggleCheckbox, {
                              key: 1,
                              value: user.subscriptionTransaction!.processed,
                              onToggle: ($event: any) => (markAsInvoiceAsPaid(user.subscriptionTransaction!.id))
                            }, null, 8, ["value", "onToggle"]))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_42, [
                  _createVNode(SubscriptionBadge, {
                    subscription_status: user.subscription_status!
                  }, null, 8, ["subscription_status"])
                ]),
                _createElementVNode("td", _hoisted_43, [
                  (user.subscriptionTransaction)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'Subscription Order', params: { id: user.subscriptionTransaction!.id } },
                        class: "text-blue-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_ctx.$props.showFilters && subscriptions.value)
          ? (_openBlock(), _createBlock(PaginationBar, {
              key: 0,
              meta: meta.value
            }, null, 8, ["meta"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})